import axios from 'axios';
import { API_BASE } from './config.js'
import { SNOTIFY_IGNORE_LIST } from './config.js'
import { vue_instance } from './main.js';

var axios_client = axios.create({
    baseURL: API_BASE,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Authorization' : localStorage.getItem('token')
    },
	timeout: 300000, // 300sec
});

axios_client.interceptors.request.use((req) => {
	var page_loading = true;

	if(req.data && req.data.filters){
		if(!req.data.filters.page_loading)
			page_loading = false;
	}

	if(req.url.indexOf('page_loading=false') > -1)
		page_loading = false;


	vue_instance.$store.commit('setPageLoading', page_loading);

	req.headers['X-Authorization'] = localStorage.getItem('token');

	return req;
}, (error) => {
	vue_instance.$store.commit('setPageLoading', true);
	return Promise.reject(error);
});

axios_client.interceptors.response.use((res) => {
	vue_instance.$store.commit('setPageLoading', false);
	if(res.data && res.data.message){
		if (res.data.notification_level) {
			if(res.data.notification_level == 'warning'){
				vue_instance.$snotify.warning(res.data.message, {
					timeout : 9000
				});
			}
		} else {
			//Make snotify silent if api url is defined in the list
			let clean_url = res.config.url.split('?')[0]
			if (!SNOTIFY_IGNORE_LIST.includes(clean_url)) {
				vue_instance.$snotify.success(res.data.message);
			}
		}

	}

	return res;
}, (error) => {
	var response = error.response;
	if ((!response)) {
		// network error
		vue_instance.$store.commit('setPageLoading', false);
		let router_status = {
      name:  vue_instance.$route.name,
      params: vue_instance.$route.params,
      query:  vue_instance.$route.query,
		}
		// vue_instance.$store.commit('setRouterStatus', router_status);
			// vue_instance.$store.commit('setServerError', true);
			// vue_instance.$router.push({ name: 'maintanence' });
		}
  else if (response.status >= 500) {
     if (response.config.url.includes('check-access-token')) {
      //do nothing
    } else {
      vue_instance.$snotify.error('There was a server error');
    }
      // if(this.api.checkAccessTokenResponse(response)){
      //   vue_instance.$snotify.error('There was a server error');
      // }
  } else {
    //skip
    if (response.config.url.includes('check-access-token')) {
      //do nothing
    } else {
      vue_instance.$snotify.warning(response.data.message);
    }
      // if(!this.api.checkAccessTokenResponse(response)){
			//   vue_instance.$snotify.warning(response.data.message);
      // }
		}

		vue_instance.$store.commit('setPageLoading', false);



	return Promise.reject(error.response);
});

export var api = {
	getPageLoading : function(){
		return vue_instance.page_loading;
	},
	base : function(){
		return axios_client;
	},

	get : function(url, options){


		var str_params = this.formatURLParams(options.filters);

		return this.base().get(url+str_params);
	},

	getFile : function(url, options){

		return axios.create({
	        baseURL: API_BASE,
	        withCredentials: false,
	        responseType : 'blob',
	        headers: {
	            'Accept': 'application/json',
	            'Content-Type': 'application/json',
	            'X-Authorization' : localStorage.getItem('token')
	        }
	    }).get(url);
	},

	post : function(url, data){

		var str_params = this.formatURLParams(data.filters);

		return this.base().post(url+str_params, data);
	},
	put: function (url, data) {
		var str_params = this.formatURLParams(data.filters);
   		return this.base().put(url + str_params, data);
	},

	patch : function(url, data){

		var str_params = this.formatURLParams(data.filters);

		return this.base().patch(url + str_params, data);
	},

	delete : function(url, data){

		var str_params = this.formatURLParams(data.filters);

		return this.base().delete(url + str_params, data);
	},

	formatURLParams : function(params){
		var str_params = '';
		if(params){
			str_params = '?';
			var parts = [];
			for(var i in params){
				parts.push(i + "=" + params[i]);
			}

			str_params = '?'+parts.join("&");
		}

		return str_params;
	},
  checkAccessTokenResponse: function(response){
    if(response.config){
      if(response.config.url.includes('check-access-token')){
        return false
      }else{
        return true
      }
    }else{
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/api.js